import { Collapse, makeStyles } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { beachActions } from "../../../redux";
import { getBeach } from "../../../redux/beach/selectors";
import { getHolderCity } from "../../../redux/user/selectors";
import FormBeach from "../../FormBeach";

const useStyles = makeStyles((theme) => ({
  alertMargin: {
    marginTop: theme.spacing(2),
  },
}));

const BeachUpdatePage: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const beach = useSelector(getBeach);
  const cityId = useSelector(getHolderCity);
  useEffect(() => {
    dispatch(beachActions.loadBeachById(cityId));
  }, [cityId, dispatch]);

  return (
    <>
      <Collapse in={!beach.isLoading && beach.error}>
        <Alert
          className={classes.alertMargin}
          color={"error"}
          severity={"error"}
        >
          {beach.error &&
            "Si è verificato un errore durante il caricamento della spiaggia"}
        </Alert>
      </Collapse>
      <FormBeach />
    </>
  );
};

export default BeachUpdatePage;
